import { render, staticRenderFns } from "./OfferBookingResponsesList.vue?vue&type=template&id=1ef48ff1"
import script from "./OfferBookingResponsesList.vue?vue&type=script&lang=js"
export * from "./OfferBookingResponsesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports